/**
 * Route paths used for auth-related navigation.
 */
export const AuthRoutes = {
  home: '/',
  notAuthorized: '/not-authorized',
  associationSelection: '/association-selection',
  flaggedContacts: '/flagged-contacts',
  authCallback: '/auth/callback'
} as const;

/**
 * Query parameter key for passing a message to the not-authorized page.
 */
export const MESSAGE_QUERY_PARAM = 'message';

/**
 * User-facing messages for auth failures (used in not-authorized redirects).
 */
export const AuthMessages = {
  requiredPermissions: 'You do not have the required permissions to access this application.',
  noTenants: 'No tenants assigned to user account.'
} as const;
